exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".phone-capture-form form[data-v-50937583] {\n  display: flex;\n}\n.phone-capture-form form .mr-input[data-v-50937583] {\n  -webkit-flex-basis: 100%;\n  flex-basis: 100%;\n}\n.phone-capture-form form .mr-btn[data-v-50937583] {\n  height: 45px;\n  padding: 0.5em 1em;\n  margin: 0.55em 0 0 -0.3em;\n}\n", ""]);

// exports
